import React from "react";
import { useDispatch } from "react-redux";
import { setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";

const PreviewComponent = ({ children, url, type = "video", img_url }) => {
  const dispatch = useDispatch();

  const handlePreviewClick = () => {
    // If the type is video, open the video modal
    if (type === "video") {
      dispatch(setCurrentForm("videoPlayer"));
      dispatch(setModalOpen(true));
      dispatch(
        setFormProps({
          url,
        })
      );
    } else {
      // For non-video types (e.g., pdf, png, jpg), open the URL in a new tab
      window.open(url, "_blank");
    }
  };

  return (
    <div className="preview-content-wrapper">
      <div
        className="w-100 h-100 cursor-pointer"
        style={{
          position: "relative",
          aspectRatio: "16/9",
          overflow: "hidden",
          borderRadius: "10px",
          marginTop: "10px",
        }}
        onClick={handlePreviewClick} // Handling click based on type
      >
        <img
          src={img_url}
          width="100%"
          height="120"
          style={{
            objectFit: "cover",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            height: "100%",
            width: "100%",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          {type === "video" && (
            <img src={"/assets/images/playImage.png"} width="100%" height="100%" />
          )}
        </div>
      </div>
      {/* {isModalOpen && (
        <ModalComponent
          isOpen={isModalOpen}
          children={children}
          width={600}
          closeIcon
          onCancelClick={() => {
            setIsModalOpen(false);
          }}
        >
          <ReactPlayer
            className="videoFrame"
            width={"100%"}
            url={url}
            playing={isModalOpen}
            controls
            config={{ 
              file: { 
                attributes: {
                  controlsList: 'nodownload',
                  onContextMenu: e => e.preventDefault()
                } 
              } 
            }}
          />
        </ModalComponent>
      )} */}
    </div>
  );
};

export default PreviewComponent;
